import { render, staticRenderFns } from "./FiberOpticCommunicationViz.vue?vue&type=template&id=79022efa&scoped=true"
import script from "./FiberOpticCommunicationViz.vue?vue&type=script&lang=js"
export * from "./FiberOpticCommunicationViz.vue?vue&type=script&lang=js"
import style0 from "./FiberOpticCommunicationViz.vue?vue&type=style&index=0&id=79022efa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79022efa",
  null
  
)

export default component.exports